import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/sapInventory'

const sapInventory = axios.create({
  baseURL
})

interceptorsSetup(sapInventory)

// The API gives each SAP call 30s, so a save batch of SAVE_BATCH_SIZE lines plus the
// session call fits in these. Without them a stuck request leaves the page waiting forever.
const LOAD_TIMEOUT_MS = 90000
const SAVE_TIMEOUT_MS = 240000
export const SAVE_BATCH_SIZE = 5

export default class SAPInventory {
  static async get (fiscalYear, inventoryNumber) {
    const result = await sapInventory.get('/', {
      timeout: LOAD_TIMEOUT_MS,
      params: {
        fiscalYear,
        inventoryNumber
      }
    })
    return result.data
  }

  // Resolves to { message, results: [{ Item, Material, ok, error }] }. When SAP rejects
  // a line the API answers 502 with the same body, available on the error as `data`.
  static async saveInventory (inventory) {
    const result = await sapInventory.post('/', inventory, { timeout: SAVE_TIMEOUT_MS })
    return result.data
  }
}
